import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putRegularClassSchedules = ({ id, ...data }) => {
  return api.put(`/admin/regular-class-schedules/${id}`, data);
};

export const usePutRegularClassSchedules = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: putRegularClassSchedules,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries({
        queryKey: [
          "regular-class-schedules",
          { id: args[0]?.regular_class_id },
        ],
      });
      queryClient.removeQueries({
        queryKey: ["put-regular-class-schedules-simulate"],
      });
    },
    ...restConfig,
  });
};
